import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import SEO from "@/components/SEO";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <SEO
        title="Pagina niet gevonden (404) | Bo Barbers"
        description="De pagina die je zoekt bestaat niet of is verplaatst. Ga terug naar de homepage van Bo Barbers Utrecht."
        path={location.pathname}
      />
      <div className="text-center">
        <p className="text-primary uppercase tracking-widest mb-4 text-sm font-semibold">Foutmelding</p>
        <h1 className="font-display text-9xl font-bold mb-4 text-primary">404</h1>
        <p className="mb-4 text-2xl font-display text-foreground">Oeps, Pagina Niet Gevonden!</p>
        <p className="mb-8 text-muted-foreground">De pagina die je zoekt bestaat niet.</p>
        <a 
          href="/" 
          className="inline-block bg-primary text-primary-foreground px-8 py-3 rounded hover:bg-primary/90 transition-colors font-semibold uppercase tracking-wider"
        >
          Terug Naar Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
